/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Toggle_AriaInputs */

const tr_pricing_toggle_aria = /** @type {(inputs: Pricing_Toggle_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aylık veya yıllık fiyatlandırmayı değiştir`)
};

const en_pricing_toggle_aria = /** @type {(inputs: Pricing_Toggle_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle monthly or yearly pricing`)
};

const de_pricing_toggle_aria = /** @type {(inputs: Pricing_Toggle_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwischen monatlicher und jährlicher Zahlung wechseln`)
};

const ru_pricing_toggle_aria = /** @type {(inputs: Pricing_Toggle_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить ежемесячную или ежегодную оплату`)
};

/**
* | output |
* | --- |
* | "Toggle monthly or yearly pricing" |
*
* @param {Pricing_Toggle_AriaInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_toggle_aria = /** @type {((inputs?: Pricing_Toggle_AriaInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Toggle_AriaInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_toggle_aria(inputs)
	if (locale === "de") return de_pricing_toggle_aria(inputs)
	if (locale === "ru") return ru_pricing_toggle_aria(inputs)
	return tr_pricing_toggle_aria(inputs)
});